module.exports = __webpack_public_path__ + "static/media/David_Saltrelli.d10a10f1.png";